import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
export const getJourneyObjectIdFromWorkflow = workflowCrmObject => {
  const uuid = getPropertyValue(workflowCrmObject, 'hs_uuid') || '';
  const stageUuidRegex = /(JOURNEY)-(\d*)-(0-158)-(\d*)-(\d*)/;
  const [,,,, journeyId] = stageUuidRegex.exec(uuid || '') || [];
  return journeyId;
};